const { useState, useCallback } = require('react');

const { useI18n } = require('nordic/i18n');
const { TextField } = require('@andes/textfield');
const { Button } = require('@andes/button');
const useMask = require('@andes/textfield/build/hooks/useMask');

const translate = require('../../../translation');
const ModalZipcodeV2 = require('../../ModalZipcodeV2');
const { Field, useFieldContext } = require('../Components/Form/Field');
const { useFormAddress } = require('./useFormAddress');
const { useAddressActions } = require('./userAddressActions');

const ZipcodeSearch = ({ formFields }) => {
  const { i18n } = useI18n();
  const translations = translate(i18n);
  const { deviceType, countryId } = useFormAddress();
  const { findLocationByZipCode, isZipCodeValidLen, getZipcodeMask } =
    useAddressActions();
  const [modalOpened, setModalOpened] = useState(false);
  const { setFieldsValue, getFieldsValue, setFieldsError } = useFieldContext();

  const selectedMaskOptions = getZipcodeMask({
    siteId: getFieldsValue().siteId,
  });

  useMask(formFields.zipcode.ref, { maskOptions: selectedMaskOptions });

  const isZipCodeValid = useCallback(
    ({ zipcode }) => isZipCodeValidLen({ zipcode, selectedMaskOptions }),
    [selectedMaskOptions],
  );

  const onBlurEventOfZipcode = useCallback(
    (e) => {
      const zipcode = e.target.value;

      if (zipcode?.length && !isZipCodeValid({ zipcode })) {
        setFieldsError({
          zipcode: { message: translations.SHIPPING_ERROR_INCOMPLETE_ZIPCODE },
        });
      } else {
        formFields.zipcode.onBlur(e);
      }
    },
    [formFields],
  );

  return (
    <div className="d-flex d-flex-column g-32">
      <ModalZipcodeV2
        deviceType={deviceType}
        i18n={i18n}
        open={modalOpened}
        setOpen={setModalOpened}
        populateFields={(currentStateCB) => {
          const { zipcode } = currentStateCB();
          setFieldsValue({ zipcode });
          findLocationByZipCode(zipcode);
        }}
        countryId={countryId}
        callback={findLocationByZipCode}
      />

      <Field name="zipcode">
        {({ value, field, error }) => {
          const { onChange } = field;
          return (
            <TextField
              label={translations.LABEL_ZIPCODE}
              srLabel={translations.LABEL_ZIPCODE}
              value={value}
              modifier={error && 'error'}
              helper={error?.message}
              placeholder={translations.SHIPPING_PLACEHOLDER_ZIPCODE}
              {...{ ...formFields.zipcode, ...field }}
              onBlur={onBlurEventOfZipcode}
              onChange={(e) => {
                const zipcode = e.target.value;
                onChange(e);

                if (isZipCodeValid({ zipcode })) {
                  findLocationByZipCode(zipcode);
                }
              }}
            >
              <Button
                size="small"
                className="form_address_info_modal_button"
                hierarchy="transparent"
                onClick={() => setModalOpened(true)}
              >
                {translations.MY_CODE}
              </Button>
            </TextField>
          );
        }}
      </Field>
    </div>
  );
};

module.exports = { ZipcodeSearch };
